export default "__VITE_ASSET__841916d2__"